import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@components/Typography';
import { MultiSelectLabels } from '@components/MultiSelectLabels';
import { useTranslation } from '@hooks';
import { CHANNEL } from '@constants/channels';

const LabelsFields = ({ isView, channelType, getContactsNumber, contactsNumber, labels }) => {
    const { t } = useTranslation();
    const { control, setValue } = useFormContext();

    const labelsOptions = useMemo(() => labels.map(item => ({ value: item.id, label: item.name })), [labels]);

    return (
        <div style={{ gridColumn: '1 / span 2' }}>
            <Controller
                control={control}
                name="labels"
                render={({ field, fieldState: { error }, ref }) => (
                    <div>
                        <MultiSelectLabels
                            {...field}
                            ref={ref}
                            onChange={value => {
                                setValue('labels', value, { shouldValidate: true, shouldDirty: true });
                                getContactsNumber();
                            }}
                            options={labelsOptions}
                            label={t('CampaignsPage.audience')}
                            fullWidth
                            editable={false}
                            disabled={isView}
                            error={!!error}
                        />
                    </div>
                )}
            />
            {!isView && (
                <>
                    <Typography variant="caption" sx={{ color: 'var(--text-secondary)', display: 'block' }}>
                        {t('CampaignsPage.audienceHint')}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'var(--text-secondary)' }}>
                        {t('CampaignsPage.contactsNumber', { count: contactsNumber })}
                    </Typography>
                </>
            )}
            {!isView && channelType === CHANNEL.WHATSAPP && contactsNumber > 49 && (
                <div>
                    <Typography variant="caption" sx={{ color: '#FF8700' }}>
                        {t('CampaignsPage.warningMessage')}
                    </Typography>
                </div>
            )}
        </div>
    );
};

export default LabelsFields;
